@if (facetList$ | async; as facetList) {
  @for (facet of activeFacets(); track facet.facetCode) {
    <a
      [attr.data-test]="'product-category--filters-active' + facet.facetCategoryCode + '-link'"
      class="active-facet"
      routerLink="./"
      [queryParams]="getLinkParams(facet)"
      [cxFocus]="{ key: getFocusKey(facetList, facet) }"
      role="button"
      (keydown.space)="removeFilterWithSpacebar($event)"
      [attr.aria-label]="
      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
    "
    >
      <div
        class="active-facet--content"
        [attr.data-test]="'product-category--filters-active' + facet.facetCategoryCode + '-content'"
      >
        @if (facet.facetCode === MATERIAL_APPLICATION_CODE) {
          <span
            [attr.data-test]="'product-category--filters-active' + facet.facetCategoryCode + '-feature'"
            class="material-application--feature" [ngClass]="facet?.facetValueCode[0]"
          >{{ facet?.facetValueCode[0] }}</span>
        } @else {
          <div
            class="active-facet--field"

          ><span
            [attr.data-test]="'product-category--filters-active' + facet.facetCategoryCode + '-feature'"
            class="body-medium"
          >{{ facet.facetName }}</span>: <span class="active-facet--value h-200 text-overflow"
          >{{ facet.facetValueName }}</span>
          </div>
        }
        <mat-icon class="active-facet--icon" svgIcon="close"></mat-icon>
      </div>
    </a>
  }
}
